<template>
    <div class="grid-home" style="height:100%;">
      <div class="title-box">
          工厂车间环境质量及卫生监控日报
      </div>
      <div class="wrapper">
        <div class="one grid-content">
          <span class="pre-title"></span>
          <span class="col-title">全局管控得分</span>
          <div>
            <el-row style="margin-top:10px;">
              <el-col :span="8">
                <div class="numPieDiv" id="allGauge"></div>
                <div class="title-div">日管控综合得分</div>
              </el-col>
              <el-col :span="8">
                <div class="numPieDiv" id="envGauge"></div>
                <div class="title-div">环境质量管控得分</div>
              </el-col>
              <el-col :span="8">
                <div class="numPieDiv" id="hygieneGauge"></div>
                <div class="title-div">卫生管控得分</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="two grid-content">
          <span class="pre-title"></span>
          <span class="col-title">监控对象/事件</span>
          <div style="height:160px;width:100%;">
            <el-row style="margin-top:10px;">
              <el-col :span="5">
                <div class="num-div" style="color:#3083FB">{{monitorAlarmSummary.monitoredFactoryCount}}</div>
                <div class="title-div">监控工厂数</div>
              </el-col>
              <el-col :span="5">
                <div class="num-div" style="color:#3083FB">{{monitorAlarmSummary.monitoredWorkshopCount}}</div>
                <div class="title-div">监控车间数</div>
              </el-col>
              <el-col :span="4">
                <div class="num-div" style="color:#3083FB">{{monitorAlarmSummary.monitoredSceneCount}}</div>
                <div class="title-div">监控场景数</div>
              </el-col>
              <el-col :span="5">
                <div class="num-div" style="color:rgba(0, 163, 137, 1)">{{monitorAlarmSummary.monitoredEventCount}}</div>
                <div class="title-div">AI监控事件数</div>
              </el-col>
              <el-col :span="5">
                <div class="num-div" style="color:rgba(243, 152, 0, 1)">{{monitorAlarmSummary.alarmEventCount}}</div>
                <div class="title-div">IOT报警事件数</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="three grid-content">
          <span class="pre-title"></span>
          <span class="col-title">车间达标率</span>
          <div id="radarDiv" style="height:100%;width:100%;">
          </div>
        </div>
        <div class="four grid-content">
          <span class="pre-title"></span>
          <span class="col-title">报警类型</span>
          <el-row class="alarmNum">
            <el-col :span="12" class="bjNum bjLv">{{monitorAlarmSummary.pressureDiffAlarmCount}}</el-col>
            <el-col :span="12" class="bjNum bjLan">{{monitorAlarmSummary.airCleanlinessAlarmCount}}</el-col>
          </el-row>
          <el-row class="alarmTitle">
            <el-col :span="12">压差报警</el-col>
            <el-col :span="12">空气洁净度报警</el-col>
          </el-row>
          <el-row class="alarmNum">
            <el-col :span="12" class="bjNum bjHong">{{monitorAlarmSummary.temperatureAlarmCount+monitorAlarmSummary.humidityAlarmCount}}</el-col>
            <el-col :span="12" class="bjNum bjQing">{{monitorAlarmSummary.restrictedZoneIntrusionCount}}</el-col>
          </el-row>
          <el-row class="alarmTitle">
            <el-col :span="12">温湿度报警</el-col>
            <el-col :span="12">禁区闯入报警</el-col>
          </el-row>
          <el-row class="alarmNum">
            <el-col :span="12" class="bjNum bjZi">{{monitorAlarmSummary.disinfectionComplianceAlarmCount}}</el-col>
            <el-col :span="12" class="bjNum bjCheng">{{monitorAlarmSummary.ozoneConcentrationAlarmCount}}</el-col>
          </el-row>
          <el-row class="alarmTitle">
            <el-col :span="12">洗消执行报警</el-col>
            <el-col :span="12">臭氧浓度报警</el-col>
          </el-row>
        </div>
        <div class="five grid-content">
          <span class="pre-title"></span>
          <span class="col-title">报警场景</span>
          <el-row class="alarmNum" style="margin-top: 20px;">
            <el-col :span="8" class="bjNum cjLv">{{monitorAlarmSummary.alarmFactoryCount}}</el-col>
            <el-col :span="8" class="bjNum cjHong">{{monitorAlarmSummary.alarmWorkshopCount}}</el-col>
            <el-col :span="8" class="bjNum cjLan">{{monitorAlarmSummary.alarmSceneCount}}</el-col>
          </el-row>
          <el-row class="alarmTitle">
            <el-col :span="8">报警工厂数</el-col>
            <el-col :span="8">报警车间数</el-col>
            <el-col :span="8">报警场景数</el-col>
          </el-row>
          <el-table :data="factoryWorkshopsAlarmDetailList" height="227" border style="width:100%;margin-top:10px;overflow-x:auto;" class="custom-table-header">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="工厂" prop="factoryName" width="80" header-align="center"></el-table-column>
            <el-table-column label="车间" prop="workshopName" header-align="center"></el-table-column>
            <el-table-column label="报警数" prop="alarmCount" width="60" header-align="center"></el-table-column>
          </el-table>
        </div>
        <div class="six grid-content">
          <span class="pre-title"></span>
          <span class="col-title">报告摘要</span>
          <span class="sub-title">日报仅为提示摘要，需要进一步了解详情，请查询相关明细报表。</span>
          <div>
            <!-- <div class="abstractItem">{{ item.text }}</div> -->
            <div class="abstractItem">
              <div>{{formatDateLocal(abstractScore.statDate)}}，工厂车间日管控综合得分{{abstractScore.integratedControlScore}}分，其中环境质量管控得分{{abstractScore.envControlScore}}分，卫生管控得分{{abstractScore.hygieneControlScore}}分。</div>
              <div>评分覆盖的范围是{{abstractScore.factCnt}}个工厂、{{abstractScore.workCnt}}个车间、{{abstractScore.scenCnt}}个场景。</div>
            </div>
            <div class="abstractItem">
              <div>车间环境质量方面，压差达标率是{{abstractStats.diffPressureCr}}%，空气洁净度达标率是{{abstractStats.airCleanlinessCr}}%，温湿度合格率是{{abstractStats.tempHumidityCr}}%。</div>
              <div>车间卫生方面，人员洗消达标率是{{abstractStats.personnelWashCr}}%，禁区禁行执行率是{{abstractStats.ozoneConcCr}}%，臭氧浓度合格率是{{abstractStats.zoneRestrictCr}}%。</div>
            </div>
            <div class="abstractItem">
              <div>发生的报警事件，共有{{alarmComputation.alarmEventCount}}起；相关AI监控事件{{alarmComputation.monitoredEventCount}}起。</div>
              <div>按报警类型统计，压差报警数是{{monitorAlarmSummary.pressureDiffAlarmCount}}(已处理{{ monitorAlarmSummary.handlePressureDiffAlarmCount }})，
                空气洁净度报警数是{{monitorAlarmSummary.airCleanlinessAlarmCount}}(已处理{{ monitorAlarmSummary.handleAirCleanlinessAlarmCount }})，
                温度报警数是{{monitorAlarmSummary.temperatureAlarmCount}}(已处理{{ monitorAlarmSummary.handleTemperatureAlarmCount }})，
                湿度报警数是{{monitorAlarmSummary.humidityAlarmCount}}(已处理{{ monitorAlarmSummary.handleHumidityAlarmCount }})，
                洗消执行报警数是{{monitorAlarmSummary.disinfectionComplianceAlarmCount}}(已处理{{ monitorAlarmSummary.handleDisinfectionComplianceAlarmCount }})，
                禁区闯入报警数是{{monitorAlarmSummary.restrictedZoneIntrusionCount}}(已处理{{ monitorAlarmSummary.handleRestrictedZoneIntrusionCount }})，
                臭氧浓度报警数是{{monitorAlarmSummary.ozoneConcentrationAlarmCount}}(已处理{{ monitorAlarmSummary.handleOzoneConcentrationAlarmCount }})。</div>
            </div>
            <div class="abstractItem">
              <div>报警事件涉及{{alarmComputation.alarmFactoryCount}}个工厂，{{alarmComputation.alarmWorkshopCount}}个车间，{{alarmComputation.alarmSceneCount}}个场景。</div>
              <div v-if="alarmComputation. alarmSceneTop1">其中报警数TOP5的场景，按从多到少排序，分别是
                {{ alarmComputation. alarmSceneTop1}}
                <span v-if="alarmComputation. alarmSceneTop2">、{{ alarmComputation. alarmSceneTop2}}</span>
                <span v-if="alarmComputation. alarmSceneTop3">、{{ alarmComputation. alarmSceneTop3}}</span>
                <span v-if="alarmComputation. alarmSceneTop4">、{{ alarmComputation. alarmSceneTop4}}</span>
                <span v-if="alarmComputation. alarmSceneTop5">、{{ alarmComputation. alarmSceneTop5}}</span>。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
  export default {
    data() {
      return {
        factoryWorkshopsAlarmDetailList: [],
        allGauge:null,
        envGauge:null,
        hygieneGauge:null,
        radarChart:null,
        resizeHandler: null,
        abstractStats:{//车间达标率日报告摘要
          statDate: "",
          diffPressureCr: 0,
          ozoneConcCr: 0,
          personnelWashCr: 0,
          zoneRestrictCr: 0,
          tempHumidityCr: 0,
          airCleanlinessCr: 0
        },
        abstractScore:{//管控得分日报告摘要
          statDate: "",
          envControlScore: 0,
          hygieneControlScore: 0,
          integratedControlScore: 0,
          factCnt:0,
          workCnt: 2,
          scenCnt: 13
        },
        monitorAlarmSummary:{
          statDate: "",
          monitoredFactoryCount: 0,
          monitoredWorkshopCount: 0,
          monitoredSceneCount: 0,
          monitoredEventCount: 0,
          alarmEventCount: 0,
          alarmFactoryCount: 0,
          alarmWorkshopCount: 0,
          alarmSceneCount: 0,
          pressureDiffAlarmCount: 0,
          airCleanlinessAlarmCount: 0,
          temperatureAlarmCount: 0,
          humidityAlarmCount: 0,
          ozoneConcentrationAlarmCount: 0,
          restrictedZoneIntrusionCount: 0,
          disinfectionComplianceAlarmCount: 0
        },
        alarmComputation:{
          pressureDiffAlarmPercentage: "",
          airCleanlinessAlarmPercentage: "",
          temperatureHumidityAlarmPercentage: "",
          ozoneConcentrationAlarmPercentage: "",
          restrictedZoneIntrusionPercentage: "",
          disinfectionComplianceAlarmPercentage: "",
          alarmSceneTop1: "",
          alarmSceneTop2: "",
          alarmSceneTop3: "",
          alarmSceneTop4: "",
          alarmSceneTop5: ""
        }
      }
    },
    activated() {
      if(this.$store.state.login.token){
        this.resizeHandler();
        window.addEventListener('resize', this.resizeHandler);
      }
    },
    deactivated() {
      if(this.$store.state.login.token){
        this.disposeHandler();
      }
      window.removeEventListener('resize', this.resizeHandler);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.resizeHandler);
    },
    mounted() {
      this.getGlobalScore();
      this.getComplianceRateData();
      this.initAbstract();
      this.resizeHandler = () => {
        if(this.$store.state.login.token){
          if(this.allGauge){
            this.allGauge.resize();
            this.envGauge.resize();
            this.hygieneGauge.resize();
          }
          else{
            this.getGlobalScore();
          }
          if(this.radarChart){
            this.radarChart.resize();
          }
          else{
            this.getComplianceRateData();
          }
        }
      };
    },
    methods: {
      formatDateLocal(dateString){
        let date = new Date(dateString);
        const formattedDate = `${date.getFullYear()}年${(date.getMonth() + 1).toString().padStart(2, '0')}月${date.getDate().toString().padStart(2, '0')}日`;
        return formattedDate
      },
      getScoreColor(score){
        if(score >= 90){
          return 'rgba(0, 173, 163, 1)';
        }else if(score >= 75){
          return 'rgba(243, 152, 0, 1)';
        }else{
          return 'rgba(255, 91, 91, 1)';
        }
      },
      // 查询摘要数据
      initAbstract(){
        this.$store.dispatch('home/getCompStatsDaily').then((result)=>{
          if(result?.data){
            this.abstractStats = result.data
          }
        })
        this.$store.dispatch('home/getCompScoreDaily').then((result)=>{
          if(result?.data){
            this.abstractScore = result.data
          }
        })
        this.$store.dispatch('home/getDailyMonitoringAlarm').then((result)=>{
          if(result?.data){
            this.monitorAlarmSummary = result.data.dailyMonitoringAlarmSummary
            this.factoryWorkshopsAlarmDetailList = result.data.dailyMonitoringAlarmWorkshopDetailList
            this.alarmComputation = result.data.alarmComputationReport
          }
        })
      },
      // 管控得分图表
      initNumGauge(id,color,num){
        let chartDom = document.getElementById(id);
        if(chartDom){
          this[id] = echarts.init(chartDom);
          let option = {
              series: [
                  {
                      type: 'gauge',
                      startAngle: -270,
                      endAngle: 90,
                      radius:'100%',
                      min: 0,
                      max: 100,
                      pointer: {
                        show: false
                      },
                      progress: {
                        show: true,
                        roundCap: true,
                        width:6,
                        itemStyle: {
                          color
                        }
                      },
                      detail: {
                        fontSize: 16,
                        color,
                        offsetCenter: [0, 0]
                      },
                      splitLine: {
                        show: false
                      },
                      axisTick: {
                        show: false
                      },
                      axisLabel: {
                        show: false
                      },
                      axisLine: {
                        roundCap: true,
                        lineStyle: {
                          width: 10
                        }
                      },
                      data: [{value: num}]
                  }
              ]
          };
          option && this[id].setOption(option);
        }
      },
      // 查询全局管控得分
      getGlobalScore(){
        this.$store.dispatch('home/getQualityDailyReport').then((result)=>{
          let arr = []
          if(result?.data){
            let data = result?.data;
            this.$nextTick(()=>{
              this.initNumGauge('allGauge',this.getScoreColor(data.integratedControlScore),data.integratedControlScore);
              this.initNumGauge('envGauge',this.getScoreColor(data.envControlScore),data.envControlScore);
              this.initNumGauge('hygieneGauge',this.getScoreColor(data.hygieneControlScore),data.hygieneControlScore);
            })
          }
        })
      },
      // 车间达标率柱状图
      initRadar(data){
        let chartDom = document.getElementById('radarDiv');
        if(chartDom){
          this.radarChart = echarts.init(chartDom);
          let option = {
            radar: {
              shape: 'circle',
              radius:'50%',
              center:['50%',"40%"],
              splitArea: {
                areaStyle: {
                  opacity: 0
                }
              },
              indicator: [
                { name: '压差达标率', max: 100, color:'rgba(7, 7, 7, 1)' },
                { name: '空气洁净度达标率', max: 100, color:'rgba(7, 7, 7, 1)' },
                { name: '温湿度达标率', max: 100, color:'rgba(7, 7, 7, 1)' },
                { name: '禁区禁行执行率', max: 100, color:'rgba(7, 7, 7, 1)' },
                { name: '人员洗消执行率', max: 100, color:'rgba(7, 7, 7, 1)' },
                { name: '臭氧消杀浓度达标率', max: 100, color:'rgba(7, 7, 7, 1)' }
              ] 
            },
            series: [
              {
                type: 'radar',
                data: [
                  {
                    value: data,
                    itemStyle:{
                      color:function(params){
                        const colors = ['rgba(1, 236, 146, 1)','rgba(249, 174, 58, 1)','rgba(59, 138, 251, 1)','rgba(2, 227, 218, 1)','rgba(253, 64, 90, 1)','rgba(75, 190, 255, 1)']
                        return colors[params.dataIndex];
                      }
                    },
                    label: {
                      show: true,
                      formatter: function (params) {
                        if(params.dimensionIndex==0){
                          return params.value?`{a|${params.value}%}`:'';
                        }
                        else if(params.dimensionIndex==1){
                          return params.value?`{b|${params.value}%}`:'';
                        }
                        else if(params.dimensionIndex==2){
                          return params.value?`{c|${params.value}%}`:'';
                        }
                        else if(params.dimensionIndex==3){
                          return params.value?`{d|${params.value}%}`:'';
                        }
                        else if(params.dimensionIndex==4){
                          return params.value?`{e|${params.value}%}`:'';
                        }
                        else if(params.dimensionIndex==5){
                          return params.value?`{f|${params.value}%}`:'';
                        }
                      },
                      rich: {
                        a: {
                          color: 'rgba(1, 236, 146, 1)',
                          align: 'center'
                        },
                        b: {
                          color: 'rgba(249, 174, 58, 1)',
                          align: 'center'
                        },
                        c: {
                          color: 'rgba(59, 138, 251, 1)',
                          align: 'center'
                        },
                        d: {
                          color: 'rgba(2, 227, 218, 1)',
                          align: 'center'
                        },
                        e: {
                          color: 'rgba(253, 64, 90, 1)',
                          align: 'center'
                        },
                        f: {
                          color: 'rgba(75, 190, 255, 1)',
                          align: 'center'
                        }
                      }
                    }
                  }
                ],
                axisLine: {
                  lineStyle: {
                    color: "rgba(0, 0, 0, 0.1)"
                  }
                },
                lineStyle:{
                  opacity:0
                },
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: 'rgba(48, 131, 251, 0.3)',
                      offset: 0
                    },
                    {
                      color: 'rgba(48, 131, 251, 0.3)',
                      offset: 1
                    }
                  ])
                }
              }
            ]
          };
          option && this.radarChart.setOption(option);
        }
      },
      // 查询车间达标率列表
      getComplianceRateData(){
        this.$store.dispatch('home/getComplianceRateDaily').then((result)=>{
          let arr = []
          if(result?.data){
            let data = result?.data
            arr.push(data.diffPressureCr)
            arr.push(data.airCleanlinessCr)
            arr.push(data.tempHumidityCr)
            arr.push(data.zoneRestrictCr)
            arr.push(data.personnelWashCr)
            arr.push(data.ozoneConcCr)
          }
          this.$nextTick(()=>{
            this.initRadar(arr)
          })
        })
      },
      disposeHandler(){
        if(this.allGauge){
          this.allGauge.dispose();
          this.allGauge = null;
        }
        if(this.envGauge){
          this.envGauge.dispose();
          this.envGauge = null;
        }
        if(this.hygieneGauge){
          this.hygieneGauge.dispose();
          this.hygieneGauge = null;
        }
        if(this.radarChart){
          this.radarChart.dispose();
          this.radarChart = null;
        }
      }
    }
}
</script>
<style lang="scss" scoped>
  .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
  .grid-home {
    overflow-y: auto;
    .grid-content{
      background: #fff;
      border-radius: 3px;
      padding: 10px;
      .pre-title{
          display: inline-block;
          width: 3px;
          height: 12px;
          background-color: #3083FB;
          border-radius: 1.5px;
          margin-right: 5px;
          margin-bottom: -1.5px;
      }
      .col-title{
        font-size: 14px;
      }
      .sub-title{
        display: inline-block;
        font-size: 12px;
        text-align: right;
        width: calc(100% - 67px);
      }
      .abstractItem{
        padding: 10px;
        border-bottom: 1px solid rgba(237, 240, 245, 1);
        font-size: 12px;
        color:rgba(72, 73, 76, 1);
        text-indent: 24px;
      }
      .numPieDiv{
        height: 60px;
      }
      .num-div{
        font-size: 22px;
        font-weight: bold;
        margin-top: 26px;
        text-align: center;
      }
      .title-div{
        font-size: 12px;
        color:#666666;
        text-align: center;
      }
      .alarmNum{
        font-size: 26px;
        text-align: center;
        height: 50px;
        margin-top: 30px;
      }
      .alarmTitle{
        font-size: 12px;
        color: #666666;
        text-align: center;
      }
      .bjNum{
        line-height: 56px;
      }
      .bjLv{
        background: url('../../assets/home/bj-lv.png') center/56px no-repeat;
      }
      .bjLan{
        background: url('../../assets/home/bj-lan.png') center/56px no-repeat;
      }
      .bjCheng{
        background: url('../../assets/home/bj-cheng.png') center/56px no-repeat;
      }
      .bjHong{
        background: url('../../assets/home/bj-hong.png') center/56px no-repeat;
      }
      .bjQing{
        background: url('../../assets/home/bj-qing.png') center/56px no-repeat;
      }
      .bjZi{
        background: url('../../assets/home/bj-zi.png') center/56px no-repeat;
      }
      .cjHong{
        background: url('../../assets/home/cj-hong.png') center/56px no-repeat;
      }
      .cjLan{
        background: url('../../assets/home/cj-lan.png') center/56px no-repeat;
      }
      .cjLv{
        background: url('../../assets/home/cj-lv.png') center/56px no-repeat;
      }
    }
  } 

.wrapper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  /*  声明行的高度  */
  grid-template-rows: 140px 368px 373px;
  .one {
    grid-column: 1 / 3;
    grid-row: 1;
  }
  .two { 
    grid-column: 3 / 5;
    grid-row: 1;
  }
  .three {
    grid-column: 1/3;
    grid-row: 2;
  }
  .four {
    grid-column: 3/4;
    grid-row: 2;
  }
  .five {
    grid-column: 4/5;
    grid-row: 2;
  }
  .six {
    grid-column: 1/5;
    grid-row: 3;
  }
}
/* 表头背景色 */
  ::v-deep .custom-table-header th{
      background-color: #ebeef5 !important;
  }
  ::v-deep .custom-table-header .el-table__row{
      height: 10px; /* 设置你想要的行高 */
  }
  ::v-deep .custom-table-header .el-table__body-wrapper{
    overflow-x: hidden;
  }
   /* 表格内边距 */
    ::v-deep .custom-table-header .el-table__cell {
        padding: 5px 0;
    }
  /* 表格字体大小 */
  .el-table {
      font-size: 12px;
  }

</style>